import React from 'react';
import { GameHowToPlayTrigger } from '../GameHowToPlayTrigger/GameHowToPlayTrigger';
import './CozyPlayShell.css';

/**
 * Pill-style Daily / Practice toggle.
 */
export function CozyModeTabs({ mode, onModeChange, disabled = false }) {
  return (
    <div className="cozy-mode-tabs" role="tablist" aria-label="Game mode">
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'daily'}
        className={`cozy-mode-tabs__pill ${mode === 'daily' ? 'cozy-mode-tabs__pill--active' : ''}`}
        onClick={() => onModeChange('daily')}
        disabled={disabled}
      >
        Daily
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'practice'}
        className={`cozy-mode-tabs__pill ${mode === 'practice' ? 'cozy-mode-tabs__pill--active' : ''}`}
        onClick={() => onModeChange('practice')}
        disabled={disabled}
      >
        Practice
      </button>
    </div>
  );
}

/**
 * Shared cozy game chrome (REDESIGN.md — Cozy Play Shell).
 */
export default function CozyPlayShell({
  title,
  subtitle,
  mode,
  onModeChange,
  modeTabsDisabled = false,
  showModeTabs = true,
  meta,
  headerExtra,
  onHowToPlay,
  children,
  footer,
  className = '',
}) {
  return (
    <div className={`cozy-play-shell ${className}`.trim()}>
      <header className="cozy-play-shell__header">
        <div className="cozy-play-shell__title-row">
          <h1 className="cozy-play-shell__title">{title}</h1>
          {onHowToPlay ? (
            <GameHowToPlayTrigger compact onClick={onHowToPlay} />
          ) : null}
        </div>
        {showModeTabs && onModeChange ? (
          <CozyModeTabs
            mode={mode}
            onModeChange={onModeChange}
            disabled={modeTabsDisabled}
          />
        ) : null}
        {subtitle ? <p className="cozy-play-shell__subtitle">{subtitle}</p> : null}
        {headerExtra ? <div className="cozy-play-shell__extra">{headerExtra}</div> : null}
        {meta ? <div className="cozy-play-shell__meta">{meta}</div> : null}
      </header>
      <div className="cozy-play-shell__play">{children}</div>
      {footer ? <div className="cozy-play-shell__footer">{footer}</div> : null}
    </div>
  );
}
